import React, { useEffect, useState } from "react";
import courseVideo from "./videos.module.css";
import assignmentStyle from "./assignment.module.css";
import details from "./details.module.css";
import {
  CourseLabelIcon,
  StudentEmergIcon,
  UploadWhiteIcon,
  WhiteatchIcon,
} from "../../svg";
import api from "../helper/Api";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../redux/userSlice";
import Toastify from "../helper/Toastify";
import { getSubmittedAssignment } from "../redux/courseSlice";
import { CircularProgress } from "@mui/material";
import { unwrapResult } from "@reduxjs/toolkit";

const Assignment = ({
  activeAssignmentData,
  isCompleted,
  courseType,
  courseId,
}) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { submittedAssignmentData, isLoading } = useSelector(
    (state) => state.courses
  );
  console.log("submitttedAssignmentData", submittedAssignmentData);
  console.log("activeAssignmentData", activeAssignmentData);
  const id = activeAssignmentData?.courseId;

  const [loadingStates, setLoadingStates] = useState({
    downloadMaterial: false,
    uploadAssignment: false,
    reSubmitAssignment: false,
  });

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getSubmittedAssignment(courseId));
  }, [dispatch, courseId]);

  const formatDate = (date) => {
    const dateFromMongoDB = new Date(date);
    const formattedDate = dateFromMongoDB.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short", // This will give abbreviated month names (e.g., Dec)
      year: "numeric",
    });
    return formattedDate;
  };

  const callMaterialsApi = async () => {
    try {
      const data = {
        studentId: user?._id,
        assignmentId: activeAssignmentData?._id,
      };
      const { status } = await api.downloadAssignment(data);

      if (status === 200) {
        const result = await dispatch(getSubmittedAssignment(courseId));
        await unwrapResult(result);

        Toastify.success("Materials Downloaded Successfully");
      } else {
        Toastify.error("Failed to log download activity");
      }
    } catch (error) {
      console.error("Error logging download:", error);
      Toastify.error("An error occurred while logging the download");
    }
  };

  const submitMaterialsApi = async (uploadData) => {
    setLoadingStates((prev) => ({ ...prev, uploadAssignment: true }));

    try {
      const data = {
        studentId: user?._id,
        courseId: id,
        content: uploadData,
      };
      const { status } = await api.submitAssignment(data);

      if (status === 200) {
        const result = await dispatch(getSubmittedAssignment(courseId));
        await unwrapResult(result);
        Toastify.success("Materials Submitted Successfully");
      } else {
        Toastify.error("Failed to log download activity");
      }
    } catch (error) {
      console.error("Error logging download:", error);
      Toastify.error(
        error.response.data.message ||
        "An error occurred while logging the download"
      );
    } finally {
      setLoadingStates((prev) => ({ ...prev, uploadAssignment: false }));
    }
  };

  const downloadMaterial = async () => {
    setLoadingStates((prev) => ({ ...prev, downloadMaterial: true }));

    const materialUrl =
      submittedAssignmentData?.length > 0
        ? submittedAssignmentData[0]?.assignmentId?.material?.[0]
        : activeAssignmentData?.material?.[0]; // Access the first material if it's an array
    if (materialUrl) {
      try {
        // // Create a link element dynamically
        // const link = document.createElement('a');
        // link.href = materialUrl;

        // // Use the Content-Disposition filename from the response or fallback to URL
        // link.download = materialUrl.split('/').pop(); // Extract the filename from the URL

        // // Append to the document and trigger the download
        // document.body.appendChild(link);
        // link.click();

        // // Clean up by removing the link element after download
        // document.body.removeChild(link);
        window.open(materialUrl, "_blank");

        // Log the download via API
        await callMaterialsApi();
      } catch (error) {
        console.error("Error downloading material:", error);
        Toastify.error("An error occurred while downloading the material");
      } finally {
        setLoadingStates((prev) => ({ ...prev, downloadMaterial: false }));
      }
    } else {
      alert("No material available to download.");
      setLoadingStates((prev) => ({ ...prev, downloadMaterial: false }));
    }
  };

  // const studentUploadsMaterial = async () => {
  //   const materialUrl = submittedAssignmentData[0]?.content?.[0]; // Access the first material if it's an array
  //   if (materialUrl) {
  //     try {
  //       // Create a link element dynamically
  //       const link = document.createElement("a");
  //       link.href = materialUrl;

  //       // Use the Content-Disposition filename from the response or fallback to URL
  //       link.download = materialUrl.split("/").pop(); // Extract the filename from the URL

  //       // Append to the document and trigger the download
  //       document.body.appendChild(link);
  //       link.click();

  //       // Clean up by removing the link element after download
  //       document.body.removeChild(link);

  //       // Log the download via API
  //     } catch (error) {
  //       console.error("Error downloading material:", error);
  //       Toastify.error("An error occurred while downloading the material");
  //     }
  //   } else {
  //     alert("No material available to download.");
  //   }
  // };

  const studentUploadsMaterial = async () => {
    const materialUrl = submittedAssignmentData[0]?.content?.[0]; // Access the first material if it's an array
    if (materialUrl) {
      try {
        // Open the material URL in a new window
        window.open(materialUrl, '_blank');

        // Log the action via API if needed
      } catch (error) {
        console.error("Error opening material:", error);
        Toastify.error("An error occurred while opening the material");
      }
    } else {
      alert("No material available to view.");
    }
  };

  const handleFileChange = async (e) => {
    setLoadingStates((prev) => ({ ...prev, uploadAssignment: true }));

    const file = e.target.files[0];
    console.log("file=========", file);

    if (file && file.type === "application/pdf") {
      const body = new FormData();
      body.set("image", file); // Adjust if API expects a different key for file

      try {
        // Upload file to the server
        const { data, status } = await api.fileUpload(body);
        console.log("Uploaded file data", data);

        if (status === 200) {
          // Set the uploaded file in Formik's attachFiles array
          const uploadData = data.data;
          submitMaterialsApi(uploadData);
        }
      } catch (error) {
        Toastify.error(error.response.data.message || `something went wrong`);
        console.error("Error uploading file:", error);
      } finally {
        setLoadingStates((prev) => ({ ...prev, uploadAssignment: false }));
      }
    } else {
      Toastify.error("Only PDF files are allowed.");
      console.error("Only PDF files are allowed.");
      setLoadingStates((prev) => ({ ...prev, uploadAssignment: false }));
    }
  };

  const handleReSubmitFileChange = async (e) => {
    setLoadingStates((prev) => ({ ...prev, reSubmitAssignment: true }));

    const file = e.target.files[0];
    console.log("file=========", file);

    if (file && file.type === "application/pdf") {
      const body = new FormData();
      body.set("image", file); // Adjust if API expects a different key for file

      // Upload file to the server

      try {
        const { data, status } = await api.fileUpload(body);
        console.log("Uploaded file data", data);

        if (status === 200) {
          // Set the uploaded file in Formik's attachFiles array
          const uploadData = data.data;
          await reSubmitAssignmentApi(uploadData);
        }
      } catch (error) {
        Toastify.error(error.response.data.message || `something went wrong`);
        console.error("Error uploading file:", error);
      } finally {
        setLoadingStates((prev) => ({ ...prev, reSubmitAssignment: false }));
      }
    } else {
      console.error("Only PDF files are allowed.");
    }
  };
  //
  const reSubmitAssignmentApi = async (uploadData) => {
    setLoadingStates((prev) => ({ ...prev, reSubmitAssignment: true }));
    try {
      const data = {
        id: submittedAssignmentData[0]?._id,
        content: uploadData,
      };
      const { status } = await api.reSubmitAssignment(data);

      if (status === 200) {
        const result = await dispatch(getSubmittedAssignment(courseId));
        await unwrapResult(result);
        Toastify.success("Materials Resubmitted Successfully");
      } else {
        Toastify.error("Failed to log download activity");
      }
    } catch (error) {
      console.error("Error logging download:", error);
      Toastify.error(
        error.response.data.message ||
        "An error occurred while logging the download"
      );
    } finally {
      setLoadingStates((prev) => ({ ...prev, reSubmitAssignment: false }));
    }
  };

  return (
    <>
      {isLoading ? (
        <div
          style={{
            display: "grid",
            placeItems: "center",
            height: "50vh",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div
          className={courseVideo.courseCertification}
          style={{ marginTop: 20 }}
        >
          <div className={courseVideo.authorName}>Course Assignment</div>
          {(isCompleted?.length === 0 && activeAssignmentData !== null) ||
            submittedAssignmentData?.length > 0 ||
            (courseType === `LIVESTREAM` && activeAssignmentData !== null) ? (
            <>
              <div className={assignmentStyle.assignmentInfo}>
                <div className={assignmentStyle.author}>
                  <img
                    src={
                      submittedAssignmentData?.length > 0
                        ? submittedAssignmentData[0]?.assignmentId?.createdBy
                          ?.profileImg[0]
                        : activeAssignmentData?.createdBy?.profileImg[0]
                    }
                    alt="Author"
                    className={assignmentStyle.authorImage}
                  />
                  <div className={assignmentStyle.authorDetails}>
                    <p>
                      {submittedAssignmentData?.length > 0
                        ? submittedAssignmentData[0]?.assignmentId?.createdBy
                          ?.name
                        : activeAssignmentData?.createdBy?.name}
                    </p>
                    <span>
                      Posted on{" "}
                      <span style={{ color: "#7B8392" }}>
                        {formatDate(
                          submittedAssignmentData?.length > 0
                            ? submittedAssignmentData[0]?.assignmentId
                              ?.createdAt
                            : activeAssignmentData?.createdAt
                        )}
                      </span>{" "}
                    </span>
                  </div>
                </div>
                <h3>
                  {submittedAssignmentData?.length > 0
                    ? submittedAssignmentData[0]?.assignmentId?.title
                    : activeAssignmentData?.title}
                </h3>
                <p className={assignmentStyle.description}>
                  {submittedAssignmentData?.length > 0
                    ? submittedAssignmentData[0]?.assignmentId?.subTitle
                    : activeAssignmentData?.subTitle}
                </p>
                {/* <div className={assignmentStyle.courseInfo}>
                                        <div className={details.iconclock}><WhiteatchIcon /> <span>Course Duration </span></div>
                                        <div className={details.detailsText}>{activeAssignmentData?.duration} Days</div>
                                    </div> */}
                <div className={assignmentStyle.courseInfo}>
                  <div className={assignmentStyle.iconclock}>
                    <CourseLabelIcon /> <span>Course Level </span>
                  </div>
                  <div className={assignmentStyle.detailsText}>
                    {submittedAssignmentData?.length > 0
                      ? submittedAssignmentData[0]?.assignmentId
                        ?.assignmentLevel
                      : activeAssignmentData?.assignmentLevel}
                  </div>
                </div>
                <div className={assignmentStyle.courseInfo}>
                  <div className={assignmentStyle.iconclock}>
                    <StudentEmergIcon /> <span>Grading Criteria </span>
                  </div>
                  <div className={assignmentStyle.detailsText}>
                    {submittedAssignmentData?.length > 0
                      ? submittedAssignmentData[0]?.assignmentId
                        ?.gradingCriteria
                      : activeAssignmentData?.gradingCriteria}
                    %
                  </div>
                </div>
                <div className={assignmentStyle.courseInfo}>
                  <div className={assignmentStyle.iconclock}>
                    <WhiteatchIcon /> <span>Deadline </span>
                  </div>
                  <div className={assignmentStyle.detailsText}>
                    {submittedAssignmentData?.length > 0
                      ? formatDate(
                        submittedAssignmentData[0]?.assignmentId?.deadlineDate
                      )
                      : formatDate(activeAssignmentData?.deadlineDate)}
                  </div>
                </div>

                {/* {!submittedAssignmentData[0]?.downloadedDate && ( */}
                <button
                  className={assignmentStyle.downloadBtn}
                  style={{
                    width: "180px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={downloadMaterial}
                >
                  {/* <img src='/eventNote.png' alt='Download' />
                                        Download Material */}
                  {loadingStates.downloadMaterial ? (
                    <CircularProgress size={24} style={{ color: "white" }} />
                  ) : (
                    <>
                      <img src="/eventNote.png" alt="Download" />
                      Download Material
                    </>
                  )}
                </button>
                {/* )} */}

                <div
                  className={assignmentStyle.bottomLineStyle}
                  style={{ marginTop: 20, marginBottom: 20 }}
                />
                <div className={courseVideo.authorName}>Student Submission</div>
                {submittedAssignmentData[0]?.isSubmitted !== true ? (
                  <div
                    className={assignmentStyle.uploadBtn}
                    style={{
                      opacity: !Array.isArray(submittedAssignmentData)
                        ? 0.4
                        : 1,
                      cursor: !Array.isArray(submittedAssignmentData)
                        ? "crosshair"
                        : "pointer",
                    }}
                  >
                    <div
                      style={{
                        cursor: !Array.isArray(submittedAssignmentData)
                          ? "crosshair"
                          : "pointer",
                        width: loadingStates.uploadAssignment
                          ? "160px"
                          : "fit-content",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <input
                        type="file"
                        accept="application/pdf"
                        id="imageFile"
                        style={{
                          display: "none",
                          cursor: !Array.isArray(submittedAssignmentData)
                            ? "crosshair"
                            : "pointer",
                        }}
                        onChange={handleFileChange}
                        disabled={!Array.isArray(submittedAssignmentData)}
                      />
                      <label
                        htmlFor="imageFile"
                        className={assignmentStyle.attachFile}
                        style={{
                          cursor: !Array.isArray(submittedAssignmentData)
                            ? "crosshair"
                            : "pointer",
                        }}
                      >
                        {/* <UploadWhiteIcon />Upload Assignment */}

                        {loadingStates.uploadAssignment ? (
                          <CircularProgress
                            size={24}
                            style={{ color: "white" }}
                          />
                        ) : (
                          <>
                            <UploadWhiteIcon />
                            Upload Assignment
                          </>
                        )}
                      </label>
                      <br />
                    </div>
                  </div>
                ) : null}
                {submittedAssignmentData[0]?.isSubmitted === true ? (
                  <div>
                    {isLoading ? (
                      <div
                        style={{
                          display: "grid",
                          placeItems: "center",
                          height: "50vh",
                        }}
                      >
                        <CircularProgress />
                      </div>
                    ) : (
                      <div>
                        <div className={assignmentStyle.courseInfo}>
                          <div className={assignmentStyle.iconclock}>
                            <WhiteatchIcon /> <span>Date of upload: </span>
                          </div>
                          <div className={assignmentStyle.detailsText}>
                            {formatDate(
                              submittedAssignmentData[0]?.submittedDate
                            )}
                          </div>
                        </div>
                        <div className={assignmentStyle.courseInfo}>
                          <div className={assignmentStyle.iconclock}>
                            <span>Student Uploads: </span>
                          </div>
                          <div
                            className={assignmentStyle.fileLink}
                            onClick={studentUploadsMaterial}
                          >
                            Filename.pdf
                          </div>
                        </div>
                        <div
                          className={courseVideo.authorName}
                          style={{ fontSize: 18, marginTop: 20 }}
                        >
                          Assignment result
                        </div>
                        <div className={assignmentStyle.courseInfo}>
                          <div className={assignmentStyle.iconclock}>
                            {" "}
                            <span>Result:</span>
                          </div>
                          <div
                            style={{
                              width: 90,
                              height: 25,
                              border:
                                submittedAssignmentData[0]?.isPassed === true
                                  ? "1px solid #00B087"
                                  : submittedAssignmentData[0]?.isPassed ===
                                    false
                                    ? "1px solid #DC3545"
                                    : "1px solid #000",
                              borderRadius: 4,
                              background:
                                submittedAssignmentData[0]?.isPassed === true
                                  ? "#16C09861"
                                  : submittedAssignmentData[0]?.isPassed ===
                                    false
                                    ? "#DC354561"
                                    : "#000",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                color:
                                  submittedAssignmentData[0]?.isPassed === true
                                    ? "#008767"
                                    : submittedAssignmentData[0]?.isPassed ===
                                      false
                                      ? "#DC3545"
                                      : "#fff",
                                fontFamily: "Inter",
                                fontSize: 14,
                                fontWeight: 600,
                                textAlign: "center",
                              }}
                            >
                              {submittedAssignmentData[0]?.isPassed === true
                                ? "Pass"
                                : submittedAssignmentData[0]?.isPassed === false
                                  ? "Failed"
                                  : "Pending"}
                            </span>
                          </div>
                        </div>
                        <div className={assignmentStyle.courseInfo}>
                          <div className={assignmentStyle.iconclock}>
                            <span>Scored Percentage:</span>
                          </div>
                          <div
                            className={assignmentStyle.detailsText}
                            style={{
                              color:
                                submittedAssignmentData[0]?.isPassed === true
                                  ? "#008767"
                                  : submittedAssignmentData[0]?.isPassed ===
                                    false
                                    ? "#DC3545"
                                    : "#000",
                            }}
                          >
                            {submittedAssignmentData[0]?.score || "0"}%
                          </div>
                        </div>
                        <div className={assignmentStyle.courseInfo}>
                          <div className={assignmentStyle.iconclock}>
                            <span>Remarks: </span>
                          </div>
                          <div className={assignmentStyle.detailsText}>
                            {submittedAssignmentData[0]?.remarks || "---"}
                          </div>
                        </div>
                        {submittedAssignmentData[0]?.isPassed === false && (
                          <div className={assignmentStyle.uploadBtn}>
                            <div
                              style={{
                                width: loadingStates.reSubmitAssignment
                                  ? "160px"
                                  : "fit-content",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <input
                                type="file"
                                accept="application/pdf"
                                id="imageFile"
                                style={{ display: "none" }}
                                onChange={handleReSubmitFileChange}
                              />
                              <label
                                htmlFor="imageFile"
                                className={assignmentStyle.attachFile}
                              >
                                {/* <img src='/eventNote.png' alt='Download' />Resubmit Assignment */}

                                {loadingStates.reSubmitAssignment ? (
                                  <CircularProgress
                                    size={24}
                                    style={{ color: "white" }}
                                  />
                                ) : (
                                  <>
                                    <img src="/eventNote.png" alt="Upload" />
                                    Resubmit Assignment
                                  </>
                                )}
                              </label>
                              <br />
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : null}
              </div>
            </>
          ) : (
            <div>
              <div className={courseVideo.descriptionText}>
                No Assignment Created yet!
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Assignment;
